import React from 'react';
import { Link } from 'gatsby'
import * as JsSearch from 'js-search';
import i18next from 'i18next'
import { GlobalContext } from '../context/globalContext';

let search = '';
let noImage = `${ process.env.GATSBY_NO_IMAGE_URL}`;

/**
 * @function addNoImage
 * @desc this function change the src image to noImage when the image is broken
 * 
 * @param {e}
 */
function addNoImage(e) {
    e.target.src = noImage;
}

class ProductTile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showOtherColors: false
        }
    }
    
    componentDidMount() {
        search = new JsSearch.Search('id');
        search.indexStrategy = new JsSearch.ExactWordIndexStrategy();
        search.addIndex('marca');
        search.addIndex('modelo');
        search.addIndex('ref');
        this.props.data.allDatoCmsProduct.edges.map(({ node: product }) => {            
            return search.addDocument(product);
        });
        var othercolors = search.search(this.props.product.modelo);

        var finalOther = [];
        othercolors.forEach((prod) => {
            var extracolor = "#" + prod.colorcrist + "#" + prod.colormont + "#" + prod.material
            if (finalOther.indexOf(extracolor) === -1) {
                finalOther.push(extracolor);
            }
        });

        this.setState({
            showOtherColors: finalOther.length > 1
        });
    }

    /**
     * @function formatCurrency
     * @desc this function change the currency format into the selected currency and language 
     * 
     * @param {locale} - locale language
     * @param {currency} - currency type
     * @param {number} - price value
     */
    formatCurrency = (locale, currency, number) => {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(number);
    }

    render(){
        let offerPrice = 0;
        let listPrice = 0;
        const locale = this.props.locale;
        let newBadgeConst = new Date();
        newBadgeConst.setDate(newBadgeConst.getDate() - (this.props.data.newBadgeDays && this.props.data.newBadgeDays.data && !isNaN(JSON.parse(this.props.data.newBadgeDays.data).days) ? JSON.parse(this.props.data.newBadgeDays.data).days : 30));

        return (
            this.props.product &&
            <div className="product" >
                <div className="product__images">
                    {
                        this.props.product.meta && this.props.product.meta.createdAt && new Date(this.props.product.meta.createdAt) < newBadgeConst &&
                        <span className="product__new-badge">{i18next.t("PDP_NEW_BADGE")}</span>
                    }
                    <Link to={'/' + this.props.locale + '/' + this.props.product.idarticulo} className="product__image" title={this.props.product.modelo}>
                        <img className="lazyload" onError={addNoImage} data-src={this.props.product.images && this.props.product.images.split(";")[0] ? this.props.product.images.split(";")[0] : noImage} alt="product"/>
                    </Link>
                </div>
                <div className="product__details">
                    <div className="product__brand">
                        {this.props.product.descripcion ? this.props.product.descripcion : (this.props.product.marca ? this.props.product.marca : this.props.product.idarticulo)}
                    </div>
                    <div className="product__prices">
                        <GlobalContext.Consumer>
                            {state => {
                                let currency = state.currency;
                                switch (currency) {
                                    case 'USD':
                                        offerPrice = this.props.product.offerpriceusd;
                                        listPrice = this.props.product.listpriceusd;
                                        break;
                                    case 'EUR':
                                        offerPrice = this.props.product.offerpriceeur;
                                        listPrice = this.props.product.listpriceeur;
                                        break;
                                    case 'GBP':
                                        offerPrice = this.props.product.offerpricegbp;
                                        listPrice = this.props.product.listpricegbp;
                                        break;
                                    default:
                                        offerPrice = 0;
                                        listPrice = 0;
                                        break;
                                }
                                return (
                                    <>
                                    {listPrice > 0 && offerPrice === listPrice &&
                                    <span className="product__price product__price--list">
                                        {this.formatCurrency(locale, currency, listPrice)}
                                    </span>
                                    }
                                    {offerPrice > 0 && offerPrice < listPrice &&
                                    <span className="product__price product__price--offer">
                                        {this.formatCurrency(locale, currency, offerPrice)}
                                    </span>
                                    }
                                    </>
                                );

                            }}
                        </GlobalContext.Consumer>
                    </div>
                    {this.state.showOtherColors && 
                        <div className="product__other">
                            <Link to={'/' + this.props.locale + '/' + this.props.product.idarticulo + '/#productColors'} className="product__image" title={this.props.product.modelo}>
                                {i18next.t('MORE_COLORS')}
                            </Link>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default ProductTile;